import {takeEvery} from 'redux-saga/effects'

import {
  ADD_SECTION,
  DELETE_MANY_SECTIONS,
  DELETE_SECTION,
  GET_SECTION,
  GET_SECTIONS,
  UPDATE_SECTION,
} from '../../../Actions/School/Section/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_SECTIONS, fetchData)
  yield takeEvery(GET_SECTION, fetchData)
  yield takeEvery(DELETE_SECTION, fetchData)
  yield takeEvery(ADD_SECTION, fetchData)
  yield takeEvery(DELETE_MANY_SECTIONS, fetchData)
  yield takeEvery(UPDATE_SECTION, fetchData)
}

export default dataSaga
